import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { returnToLogin } from '../helpers';
import { ButtonSubmit } from '@app/components';
import { SetLoginForm } from '@app/models';
import Icon from '@app/components/Icon/index';

interface IProps {
    setLoginForm?: SetLoginForm;
}
export const ResetPasswordSuccess: React.SFC<IProps> = ({setLoginForm}) => {
    const { translation } = useTypedTranslation();

    return (
        <div className='reset-password reset-password--success'>
            <div className='reset-password__icon-block'>
                <Icon icon='emailSentIco' className='reset-password__icon' />
            </div>
            <h1>{translation('RESET_TITLE_EMAIL_SENT')}</h1>
            <div className='reset-password__text--success'>{translation('RESET_EMAIL_SENT')}</div>
            <div className='reset-password__buttons'>
                <ButtonSubmit
                    className='reset-password__button'
                    buttonText={translation('RESET_BACK')}
                    disableRipple={true}
                    onClick={returnToLogin(setLoginForm)}
                    isDisabled={false}
                    isLoad={false}
                />
            </div>
        </div>
    );
};
